import DashboardIcon from '@mui/icons-material/Dashboard'
import SalesIcon from '@mui/icons-material/PaymentsOutlined'
import ProductIcon from '@mui/icons-material/ShoppingBag'
import OrderIcon from '@mui/icons-material/ListAlt'

import { SvgIcon } from '@mui/material'

export const items = [
  {
    title: 'ダッシュボード',
    path: '/',
    icon: (
      <SvgIcon fontSize="small">
        <DashboardIcon />
      </SvgIcon>
    ),
  },
  {
    title: '売上管理',
    path: '/sales',
    icon: (
      <SvgIcon fontSize="small">
        <SalesIcon />
      </SvgIcon>
    ),
  },
  {
    title: '商品管理',
    path: '/products',
    icon: (
      <SvgIcon fontSize="small">
        <ProductIcon />
      </SvgIcon>
    ),
  },
  {
    title: '注文管理',
    path: '/orders',
    icon: (
      <SvgIcon fontSize="small">
        <OrderIcon />
      </SvgIcon>
    ),
  },
  // {
  //   title: '設定',
  //   path: '/settings',
  //   icon: (
  //     <SvgIcon fontSize="small">
  //       <CogIcon />
  //     </SvgIcon>
  //   ),
  // },
]
